import { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router';
import { hashHistory } from 'utils/routes';

const BaseRouter = ({ basename, children }) => {
    const [state, setState] = useState({
        action: hashHistory.action,
        location: hashHistory.location,
    });

    useLayoutEffect(() => hashHistory.listen(setState), []);

    return (
        <Router
            basename={basename}
            location={state.location}
            navigationType={state.action}
            navigator={hashHistory}
        >
            {children}
        </Router>
    );
};

export default BaseRouter;
